import { get, post } from "../../utils/httpService";

const SERVICE_URLS = {
  getCategories: () => `/client/getCategories`,
};

export const getCategories = (body, params) => {
  return get(SERVICE_URLS.getCategories(), body, params);
};
